export default function NaverLogo() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M10.8488 8.56336L4.91703 0H0V16H5.15124V7.43664L11.083 16H16V0H10.8488V8.56336Z"
        fill="white"
      />
    </svg>
  );
}
